// extracted by mini-css-extract-plugin
export var betweenFlexContainer = "styles-module--betweenFlexContainer--38bc0";
export var bpBetweenFlexContainer = "styles-module--bpBetweenFlexContainer--c81d1";
export var checkoutWarning = "styles-module--checkoutWarning--7a9c8";
export var column = "styles-module--column--4c82a";
export var container = "styles-module--container--ca739";
export var desktop = "1340px";
export var desktopRemoveButton = "styles-module--desktopRemoveButton--f6cf6";
export var discountHint = "styles-module--discountHint--ff5d7";
export var giant = "2200px";
export var imageContainer = "styles-module--imageContainer--4b423";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var mobileRemoveButton = "styles-module--mobileRemoveButton--91782";
export var price = "styles-module--price--63518";
export var productName = "styles-module--productName--2ced2";
export var quantityContainer = "styles-module--quantityContainer--4606b";
export var quantityText = "styles-module--quantityText--9728f";
export var rightCol = "styles-module--rightCol--e6e8a";
export var rightContainer = "styles-module--rightContainer--b0e6b";
export var shade = "styles-module--shade--8146d";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var strikethrough = "styles-module--strikethrough--488c9";
export var tablet = "769px";
export var warningText = "styles-module--warningText--a075b";